import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import BreadCrumb from 'components/BreadCrumb'
import DefaultButton from 'components/DefaultButton'
import DefaultCreationForm, {
	DefaultCreationFormButtonGroup,
	DefaultCreationFormGroup,
} from 'components/DefaultCreationForm'
import DefaultInput from 'components/DefaultInput'
import { DefaultPageTitle } from 'components/DefaultPageTitle'
import { CreateAndEditCommentContainer } from './style'
import checkEmptyString from 'helpers/check-empty-string'
import { getComment, createComment, updateComment } from 'services/comments'
import { COMMENTS } from 'components/Routes/Constants'

import showErrorMessage from 'helpers/show-error-message'

interface CreateAndEditCommentProps {
	commentId: string
}

const CreateAndEditComment: React.FC = () => {
	const { commentId } = useParams<CreateAndEditCommentProps>()

	const history = useHistory()

	const [description, setDescription] = useState('')

	const createContent = async (event: React.FormEvent) => {
		event.preventDefault()

		try {
			if (checkEmptyString(description)) {
				throw new Error('Informe um comentário válido')
			}

			await createComment({
				description,
			})

			Swal.fire({
				title: 'Sucesso!',
				text: 'Comentário criado com sucesso!',
				icon: 'success',
			})

			goToComments()
		} catch (error: any) {
			var errorMessage = 'Houve um erro ao criar o comentário. Tente novamente';
			if (error.response && error.response.data.message) {
				errorMessage = error.response.data.message;
			}

			Swal.fire({
				title: 'Erro',
				text: errorMessage,
				icon: 'error',
			})
		}
	}

	const updateContent = async (event: React.FormEvent) => {
		event.preventDefault()

		try {
			if (checkEmptyString(description)) {
				throw new Error('Informe um nome válido para o profissional')
			}

			await updateComment(commentId, {
				description,
			})

			Swal.fire({
				title: 'Sucesso!',
				text: 'Comentário atualizado com sucesso!',
				icon: 'success',
			})

			goToComments()
		} catch (error) {
			showErrorMessage(error)
		}
	}

	const goToComments = () => {
		history.push(`${COMMENTS}`)
	}

	const getContent = useCallback(async () => {
		if (commentId) {
			const comment = await getComment(commentId)
			if (comment && Object.keys(comment).length) {
				setDescription(comment.description)
			}
		}
	}, [commentId])

	useEffect(() => {
		getContent()
	}, [getContent])

	const isEditting = useMemo(() => !!commentId, [commentId])

	return (
		<CreateAndEditCommentContainer>
			<BreadCrumb
				crumbs={[<Link to={`${COMMENTS}`}>Comentário</Link>, <span>{isEditting ? 'Editar' : 'Criar'} Comentário</span>]}
			/>

			<DefaultPageTitle>{isEditting ? 'Editar' : 'Criar'} Comentário</DefaultPageTitle>

			<DefaultCreationForm>
				<DefaultCreationFormGroup>
					<label className="required" htmlFor="name">
						Comentário
					</label>
					<DefaultInput value={description} onChange={(e) => setDescription(e.target.value)} id="description" required />
				</DefaultCreationFormGroup>

				<DefaultCreationFormButtonGroup>
					<DefaultButton type="button" className="danger" onClick={goToComments}>
						Cancelar
					</DefaultButton>
					<DefaultButton
						onClick={(e) => (isEditting ? updateContent(e) : createContent(e))}
						className="success"
					>
						Salvar
					</DefaultButton>
				</DefaultCreationFormButtonGroup>
			</DefaultCreationForm>
		</CreateAndEditCommentContainer>
	)
}

export default CreateAndEditComment
